import { race, delay } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestHeartbeat (action) {
  const { heartbeats } = action.payload

  const actionPromise = apiAction('Heartbeat', {
    heartbeats
  })

  const { timeout } = yield race({
    actionPromise,
    timeout: delay(30000)
  })

  if (timeout) {
    actionPromise.cancel()
  }
}
